import { render } from "./HelpAndSupport.vue?vue&type=template&id=1ccf8dfa"
import script from "./HelpAndSupport.vue?vue&type=script&lang=js"
export * from "./HelpAndSupport.vue?vue&type=script&lang=js"

import "./HelpAndSupport.vue?vue&type=style&index=0&id=1ccf8dfa&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__